import { Link } from "react-router-dom";

const screenshots = [
  {
    image: "https://storage.readdy-site.link/project_files/3c80aa7f-17f1-4cbb-ba18-b726e6f3c85d/01d7a3cf-f8a9-4b5c-b1df-6558b385a836_compressed_IMG_0928.webp",
    label: "Search any rated course",
    alt: "HANDICALC course search screen",
  },
  {
    image: "https://storage.readdy-site.link/project_files/3c80aa7f-17f1-4cbb-ba18-b726e6f3c85d/44fb3492-a255-4fa3-9c64-e8675d928e93_compressed_IMG_0929.webp",
    label: "Enter players & handicaps",
    alt: "HANDICALC player and handicap entry screen",
  },
  {
    image: "https://storage.readdy-site.link/project_files/3c80aa7f-17f1-4cbb-ba18-b726e6f3c85d/5a4012f6-089d-4e76-a725-05aeaf416d22_compressed_IMG_0930.webp",
    label: "Instant playing handicap",
    alt: "HANDICALC results screen with playing handicap",
  },
];

export default function AppScreenshots() {
  return (
    <section className="bg-background-50 py-20 md:py-28">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="max-w-2xl mx-auto text-center">
          <span className="text-xs uppercase tracking-[0.18em] text-accent-700 font-semibold">App preview</span>
          <h2 className="mt-3 font-heading font-bold text-foreground-950 text-3xl md:text-4xl lg:text-5xl leading-tight">
            <a href="#screenshots">See HANDICALC® in action</a>
          </h2>
          <p className="mt-4 text-foreground-700 text-base md:text-lg leading-relaxed">
            Three taps and you have your playing handicap. Here's what the app actually looks like — from course search to final result.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {screenshots.map((ss, i) => (
            <div key={ss.label} className="flex flex-col items-center">
              {/* Phone frame */}
              <div className="relative w-[220px] md:w-[250px] mx-auto">
                <div className="relative rounded-[2.25rem] border-[3px] border-foreground-800/80 bg-foreground-900 p-1.5">
                  {/* Status bar notch */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 w-20 h-5 bg-foreground-900 rounded-b-xl z-10"></div>
                  {/* Screen area */}
                  <div className="rounded-[1.75rem] overflow-hidden bg-background-50 aspect-[9/16]">
                    <img
                      src={ss.image}
                      alt={ss.alt}
                      className="w-full h-full object-cover object-top"
                      loading="lazy"
                    />
                  </div>
                  {/* Home indicator */}
                  <div className="mt-1.5 flex justify-center pb-0.5">
                    <div className="w-24 h-1 rounded-full bg-foreground-400/40"></div>
                  </div>
                </div>
              </div>

              {/* Step number + label */}
              <div className="mt-6 text-center">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-primary-100 text-primary-700 text-xs font-bold">
                  {i + 1}
                </span>
                <p className="mt-2 text-sm font-semibold text-foreground-900">{ss.label}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <Link
            to="/calculator"
            className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-primary-600 hover:bg-primary-700 text-background-50 text-sm md:text-base font-semibold whitespace-nowrap cursor-pointer transition-colors"
          >
            Try it yourself <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}